const block = ['top', 'bottom'] as const
const inline = ['start', 'end', 'left', 'right'] as const
type Tblock = (typeof block)[number]
type Tinline = (typeof inline)[number]

export type Anchor =
  | Tblock
  | Tinline
  | 'center'
  | 'center center'
  | `${Tblock} ${Tinline | 'center'}`
  | `${Tinline} ${Tblock | 'center'}`

export const Anchors = {
  Top: block[0],
  TopCenter: `${block[0]} center`,
  Bottom: block[1],
  BottomCenter: `${block[1]} center`,
  Start: inline[0],
  StartCenter: `${inline[0]} center`,
  End: inline[1],
  EndCenter: `${inline[1]} center`,
  Left: inline[2],
  LeftCenter: `${inline[2]} center`,
  Right: inline[3],
  RightCenter: `${inline[3]} center`
} as const
